import { TransactionInfo } from '../model/TransactionInfo';

export class TransactionInfoBuilder {

  private _transactionInfo: TransactionInfo;


  constructor(_transactionInfo?: TransactionInfo) {
    if (_transactionInfo) {
      this._transactionInfo = _transactionInfo;
    }else {
      this._transactionInfo = new TransactionInfo();
    }
  }

  setTransactionInfo(_transactionInfo: TransactionInfo) {
    this._transactionInfo = _transactionInfo;
  }

  getTransactionInfo(): TransactionInfo {
    return this._transactionInfo;
  }

  id(_id: number): TransactionInfoBuilder {
    this._transactionInfo.id = _id;
    return this;
  }

  numeroCartao(_numeroCartao: string): TransactionInfoBuilder {
    this._transactionInfo.numeroCartao = _numeroCartao;
    return this;
  }

  codAuth(_codAuth: string): TransactionInfoBuilder {
    this._transactionInfo.codAuth = _codAuth;
    return this;
  }

  codTerm(_codTerm: string): TransactionInfoBuilder {
    this._transactionInfo.codTerm = _codTerm;
    return this;
  }

  nsuTerminal(_nsuTerminal: string): TransactionInfoBuilder {
    this._transactionInfo.nsuTerminal = _nsuTerminal;
    return this;
  }

  nsuHost(_nsuHost: string): TransactionInfoBuilder {
    this._transactionInfo.nsuHost = _nsuHost;
    return this;
  }

  data(_data: string): TransactionInfoBuilder {
    this._transactionInfo.data = _data;
    return this;
  }

  hora(_hora: string): TransactionInfoBuilder {
    this._transactionInfo.hora = _hora;
    return this;
  }

  valor(_valor: string): TransactionInfoBuilder {
    this._transactionInfo.valor = _valor;
    return this;
  }

  qtdParcelas(_qtdParcelas: string): TransactionInfoBuilder {
    this._transactionInfo.qtdParcelas = _qtdParcelas;
    return this;
  }

  bandeira(_bandeira: string): TransactionInfoBuilder {
    this._transactionInfo.bandeira = _bandeira;
    return this;
  }

  modalidade(_modalidade: string): TransactionInfoBuilder {
    this._transactionInfo.modalidade = _modalidade;
    return this;
  }

  codigoSimulador(_codigoSimulador: string): TransactionInfoBuilder {
    this._transactionInfo.codigoSimulador = _codigoSimulador;
    return this;
  }

  recibo(_recibo: string): TransactionInfoBuilder {
    this._transactionInfo.recibo = _recibo;
    return this;
  }

  cpfCnpj(_cpfCnpj: string): TransactionInfoBuilder {
    this._transactionInfo.cpfCnpj = _cpfCnpj;
    return this;
  }

  vendaTx(_vendaTx: string): TransactionInfoBuilder {
    this._transactionInfo.vendaTx = _vendaTx;
    return this;
  }

  confirmaVendaTx(_confirmaVendaTx: string): TransactionInfoBuilder {
    this._transactionInfo.confirmaVendaTx = _confirmaVendaTx;
    return this;
  }

  etapaProcessamento(_etapaProcessamento: string): TransactionInfoBuilder {
    this._transactionInfo.etapaProcessamento = _etapaProcessamento;
    return this;
  }

  codigoMensagem(_codigoMensagem: string): TransactionInfoBuilder {
    this._transactionInfo.codigoMensagem = _codigoMensagem;
    return this;
  }

  codigoProcessamento(_codigoProcessamento: string): TransactionInfoBuilder {
    this._transactionInfo.codigoProcessamento = _codigoProcessamento;
    return this;
  }

  tipoTaxa(_tipoTaxa: string): TransactionInfoBuilder {
    this._transactionInfo.tipoTaxa = _tipoTaxa;
    return this;
  }

  status(_status: string): TransactionInfoBuilder {
    this._transactionInfo.status = _status;
    return this;
  }

  valorSemTaxas(_valorSemTaxas: string): TransactionInfoBuilder {
    this._transactionInfo.valorSemTaxas = _valorSemTaxas;
    return this;
  }

  tipoTransacao(_tipoTransacao: string): TransactionInfoBuilder {
    this._transactionInfo.tipoTransacao = _tipoTransacao;
    return this;
  }

  transacaoEstornoId(_transacaoEstornoId: number): TransactionInfoBuilder {
    this._transactionInfo.transacaoEstornoId = _transacaoEstornoId;
    return this;
  }

  estornoVendaTx(_estornoVendaTx: string): TransactionInfoBuilder {
    this._transactionInfo.estornoVendaTx = _estornoVendaTx;
    return this;
  }

  pinSimuladorId(_pinSimuladorId: number): TransactionInfoBuilder {
    this._transactionInfo.pinSimuladorId = _pinSimuladorId;
    return this;
  }

  modeloCaptura(_modeloCaptura: string): TransactionInfoBuilder {
    this._transactionInfo.modeloCaptura = _modeloCaptura;
    return this;
  }

  reciboUsuario(reciboUsuario: string): TransactionInfoBuilder {
    this._transactionInfo.reciboUsuario = reciboUsuario;
    return this;
  }
}
